import { render, staticRenderFns } from "./Residents.vue?vue&type=template&id=44709ece&"
import script from "./Residents.vue?vue&type=script&lang=js&"
export * from "./Residents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports